import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ButtonComponent } from '@lucca-front/ng/button';
import { IconComponent } from '@lucca-front/ng/icon';

import { AppStore } from '@src/app-store';

import { CapitalizePipe } from '../../pipes/capitalize.pipe';

@Component({
  imports: [ButtonComponent, IconComponent, CapitalizePipe],
  selector: 'app-footer',
  templateUrl: './app-footer.html',
  styleUrls: ['./app-footer.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppFooter {
  readonly store = inject(AppStore);
}
